import type {
  SreOpenBugTrendParams,
  SreOpenBugTrendResponse,
} from '../../types/sre-open-bug-trend.js';
import { request } from './_request.js';

/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business SRE未完了バグ件数推移APIクライアント。集計単位（週次/月次）を指定して期間ごとの増えた数・減った数・未完了件数を取得
 * @graph-connects /kpi/sre-open-bug-trend [calls] SRE未完了バグ件数推移API
 */
export const sreOpenBugTrendApi = {
  getTrend: async (params: SreOpenBugTrendParams): Promise<SreOpenBugTrendResponse> => {
    const query = new URLSearchParams({ unit: params.unit });
    return await request<SreOpenBugTrendResponse>(`/kpi/sre-open-bug-trend?${query.toString()}`);
  },
};
